<convfact-bankcharges-form [bankCharges]="bankCharges" *ngIf="bankCharges" (onSave)="saveData($event)">
</convfact-bankcharges-form>
